import { useQuery } from '@ts-core/lib/apollo';

import { getErrorMessage } from '@ts-core/lib/apollo';
import { useSnackbarNotifications } from '@ts-core/core/hooks/ui';

import { getGeneralRankingQuery, GetGeneralRankingQueryResult, GetGeneralRankingQueryVariables } from '../graphql/queries/getGeneralRankingQuery';
import { GeneralRankingStudent, RankingStats } from '../types';

interface GeneralLeaderboardHookInput {
  courseId: string;

  from?: string;
  to?: string;
}

interface GeneralLeaderboardHookResult {
  courseId?: string;
  courseName?: string;
  students?: GeneralRankingStudent[];
  stats?: RankingStats;

  loading: boolean;
  error?: string;
  onRefetchRanking: () => void;
}

export default function useGeneralLeaderboard(input: GeneralLeaderboardHookInput): GeneralLeaderboardHookResult {
  const { courseId, from = '', to = '' } = input;
  const { showErrorNotification } = useSnackbarNotifications();

  const { data, loading, error, refetch } = useQuery<GetGeneralRankingQueryResult, GetGeneralRankingQueryVariables>(getGeneralRankingQuery, {
    variables: {
      courseId,
      queryParams: { startDate: from, endDate: to },
    },
    onError: showErrorNotification,
  });

  return {
    ...data?.generalRankingPayload,
    loading,
    error: getErrorMessage({ error }),

    onRefetchRanking: refetch,
  };
}
